export function formatFaxOrPhoneNumber(value: string) {
  const digits = value.replace(/[^\d]/g, '');
  if (digits.length > 10) {
    return digits.replace(/^(\d{1})(\d{3})(\d{3})(\d{4}).*/, '+$1 ($2) $3-$4');
  }
  return digits.replace(/^(\d{3})(\d{3})(\d{4}).*/, '($1) $2-$3');
}

export function formatPhoneNumberWithCountryCode(value: string) {
  const digits = value.replace(/[^\d]/g, '');
  if (digits.length > 10) {
    return digits.replace(/^(\d{1})(\d{3})(\d{3})(\d{4}).*/, '+$1 $2-$3-$4');
  }
  return digits.replace(/^(\d{3})(\d{3})(\d{4}).*/, '$1-$2-$3');
}

export function formatFileSize(bytes: number): string {
  if (bytes >= 1024 * 1024 * 1024) {
    return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`;
  }
  if (bytes >= 1024 * 1024) {
    const mb = bytes / (1024 * 1024);
    return mb >= 10 ? `${Math.round(mb)} MB` : `${mb.toFixed(1)} MB`;
  }
  if (bytes >= 1024) {
    return `${Math.round(bytes / 1024)} KB`;
  }
  return `${bytes} B`;
}
